package com.essntl.uikit.key

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.focusable
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import kotlin.math.roundToInt

fun <T> Modifier.upDownSelection(
    focusRequester: FocusRequester,
    isSelected: Boolean,
    list: List<T>,
    index: Int,
    onSelect: (T) -> Unit,
    onSelectIndex: (Int) -> Unit = {},
    lazyListState: LazyListState,
    scrollTo: (Int) -> Unit,
) = this
    .upDownSelection(
        focusRequester = focusRequester,
        isSelected = isSelected,
        list = list,
        getIndex = { index },
        onSelect = onSelect,
        onSelectIndex = { newIndex ->
            if (newIndex !in lazyListState.layoutInfo.visibleItemsInfo.map { it.index })
                scrollTo(newIndex)

            onSelectIndex(newIndex)
        },
    )

fun <T> Modifier.upDownSelection(
    focusRequester: FocusRequester,
    isSelected: Boolean,
    list: List<T>,
    key: String,
    rectMap: Map<String, Rect>,
    onSelect: (T) -> Unit,
    onSelectIndex: (Int) -> Unit = {},
    scrollState: ScrollState,
    scrollTo: (Int) -> Unit,
) = this
    .upDownSelection(
        focusRequester = focusRequester,
        isSelected = isSelected,
        list = list,
        getIndex = {
            val index = list.indexOfFirst { it == key }
            index
        },
        onSelect = onSelect,
        onSelectIndex = onSelectIndex@{ newIndex ->
            val rect = rectMap[key] ?: return@onSelectIndex
            val isOnTop = rect.top < scrollState.value
            val isOnBottom = rect.bottom > scrollState.value + scrollState.viewportSize
            val scrollAmount =
                when {
                    isOnTop ->
                        rect.top - scrollState.value

                    isOnBottom ->
                        rect.bottom - scrollState.value - scrollState.viewportSize

                    else ->
                        0f
                }

            if (isOnTop || isOnBottom)
                scrollTo((scrollState.value + scrollAmount).roundToInt())

            onSelectIndex(newIndex)
        },
    )

fun <T> Modifier.upDownSelection(
    focusRequester: FocusRequester,
    isSelected: Boolean,
    list: List<T>,
    getIndex: () -> Int,
    onSelect: (T) -> Unit,
    onSelectIndex: (Int) -> Unit = {},
) = this
    .focusRequester(focusRequester)
    .focusable()
    .onKeyEvent { event ->
        if (!isSelected)
            return@onKeyEvent false

        if (event.type != KeyEventType.KeyUp)
            return@onKeyEvent false

        if (event.key != Key.DirectionUp && event.key != Key.DirectionDown)
            return@onKeyEvent false

        val index = getIndex()

        if (event.key == Key.DirectionUp) {
            val prevIndex = index - 1
            val prevItem = list.getOrNull(prevIndex)
                ?: return@onKeyEvent false

            onSelect(prevItem)
            onSelectIndex(prevIndex)
        } else {
            val nextIndex = index + 1
            val nextItem = list.getOrNull(nextIndex)
                ?: return@onKeyEvent false

            onSelect(nextItem)
            onSelectIndex(nextIndex)
        }

        true
    }